import { useParams } from 'react-router-dom';
import { UUID } from '@/types';
import React from 'react';

export const useDatasourceId = () => {
  const { datasourceId } = useParams<{ datasourceId: UUID }>();

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return datasourceId!;
};
export const useRowsRequestId = () => {
  const { rowRequestId } = useParams<{ rowRequestId: UUID }>();

  return rowRequestId;
};

const getRootElement = (id = 'root') => document.getElementById(id)!;
export const getTrackedDatasourceId = () =>
  getRootElement().dataset.datasourceId;
export const useTrackDatasourceId = () => {
  const datasourceId = useDatasourceId();

  React.useEffect(() => {
    const rootEl = getRootElement();

    if (rootEl) {
      rootEl.dataset.datasourceId = datasourceId ?? '';
    }
  }, [datasourceId]);
};
